import { create } from 'zustand';

export type CustomerStoreT = {
  currentCustomer: {
    id: string;
    name?: string;
    username?: string;
    email: string;
    phoneNumber: string;
    address: string;
    trn?: string;
    creditLimit?: number | string | null;
    creditPeriod?: number | string | null;
  } | null;
  setCurrentCustomer: (customer: CustomerStoreT['currentCustomer']) => void;
  clearCurrentCustomer: () => void;
};

const useCustomerStore = create<CustomerStoreT>(set => ({
  currentCustomer: null,
  setCurrentCustomer: customer => set({ currentCustomer: customer }),
  clearCurrentCustomer: () => set({ currentCustomer: null }),
}));

export default useCustomerStore;
